import { defineRouting } from 'next-intl/routing'
import { getDefaultLocale, getLocales } from '@/lib/routing'

export const routing = defineRouting({
  locales: getLocales(),
  defaultLocale: getDefaultLocale(),
})
